import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import * as yup from 'yup';

// material ui
import { Box, Button, Divider, FormControl, Grid, Stack, TextField, Typography } from '@mui/material';

// graphql
import { useCreateTelegramReportTypeMutation } from '@/generated/graphql';

// interfaces
import type { ICreateTelegramReportTypeInput } from '@/shared/interfaces';

import { MdOutlinePostAdd } from 'react-icons/md';

interface IUsherProps {
  refetchData: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CreateReportType = ({ open, setOpen, refetchData }: IUsherProps) => {
  const handleClose = () => setOpen(false);

  const schema = yup
    .object({
      name: yup.string().required(),
      description: yup.string().notRequired(),
    })
    .required();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ICreateTelegramReportTypeInput>({
    resolver: yupResolver(schema),
  });

  const [createReportTypeMutation] = useCreateTelegramReportTypeMutation();

  const onSubmit = async (dataInput: ICreateTelegramReportTypeInput) => {
    const { name, description } = dataInput;

    const input: ICreateTelegramReportTypeInput = {
      name,
      description,
    };
    console.log('🚀 ~ onSubmit ~ input:', input);

    const { data } = await createReportTypeMutation({
      variables: {
        input,
      },
    });

    if (data) console.log(data);
    if (errors) console.log(errors);
    refetchData();
    handleClose();
    reset();
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: 'inherit',
            backgroundColor: 'rgba(25, 25, 25, 0.75)',
          },
          content: {
            width: '440px',
            overflow: 'unset',
            position: 'absolute',
            margin: '0.1% auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: 0,
            marginRight: '-50%',
            transform: 'translate(-50%, -48vh)',
            border: '0px',
            background: 'transparent',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
          },
        }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            overflow: 'unset',
            borderRadius: '5px',
          }}
          mt={9}>
          <Box sx={{ px: 5, py: 2 }} alignItems={'center'}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography gutterBottom variant="subtitle2" m={0}>
                Create Report Type
              </Typography>
              <MdOutlinePostAdd fontSize={18} />
            </Stack>
          </Box>
          <Divider />

          <Box px={5} pt={2} pb={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid>
                <FormControl fullWidth sx={{ mt: 5 }} variant="standard">
                  <TextField label="Name" InputLabelProps={{ shrink: true }} variant="standard" {...register('name')} />
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }} variant="standard">
                  <TextField
                    id="standard-multiline-static"
                    label="Description"
                    multiline
                    rows={3}
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    {...register('description')}
                  />
                </FormControl>
              </Grid>
              <Grid container justifyContent={'end'} mt={5}>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  sx={{
                    background: 'grey',
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    textTransform: 'unset',
                  }}
                  onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  sx={{
                    ml: 1,
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    textTransform: 'unset',
                  }}
                  type="submit"
                  size="small"
                  variant="contained">
                  Create
                </Button>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
